angular.module('NumbersEditor')
    .factory('EventFactory', [
        '$http', function($http) {

            var urlBase = '/api/Event';
            var eventFactory = {};

            eventFactory.GetEvent = function(id) {
                return $http.get(urlBase + '/' + id);
            };

            eventFactory.Save = function(event) {
                return $http.post(urlBase, event);
            };

            eventFactory.Update = function(id, event) {
                return $http.put(urlBase + '/' + id, event);
            };

            eventFactory.Delete = function(id) {
                return $http.delete(urlBase + '/' + id);
            };

            eventFactory.Active = function(id) {
                return $http.post(urlBase + '/' + id + '/active');
            };

            eventFactory.StartBroadcast = function(id) {
                return $http.post(urlBase + '/' + id + '/startBroadcast');
            };

            eventFactory.EndBroadcast = function(id) {
                return $http.post(urlBase + '/' + id + '/endBroadcast');
            };

            eventFactory.Release = function(id, releasedTime) {
                var eventDtoAdd = { RefId: id, EventTime: releasedTime };
                return $http.post(urlBase + '/' + id + '/release', eventDtoAdd);
            };

            eventFactory.Cancel = function(id) {
                return $http.post(urlBase + '/' + id + '/cancel');
            };

            eventFactory.Suspend = function(id) {
                return $http.post(urlBase + '/' + id + '/suspend');
            };

            eventFactory.ChangePending = function(id) {
                return $http.post(urlBase + '/' + id + '/changePending');
            };

            eventFactory.Void = function(id) {
                return $http.post(urlBase + '/' + id + '/void');
            };

            eventFactory.FortynineDefaultEvents = function(startDate) {
                var sixteenFortyNine = 60540000; // 1970-01-01:16:49:00 
                var seventeenFortyNine = 64140000; // 1970-01-01:17:49:00
                var eventTime = undefined;

                if (startDate.getDay() == 0) {
                    eventTime = sixteenFortyNine;
                } else {
                    eventTime = seventeenFortyNine;
                }

                var events =
                [
                    {
                        EventNumber: 1,
                        EventTime: 46140000,
                        Status: "I",
                    },
                    {
                        EventNumber: 2,
                        EventTime: eventTime,
                        Status: "I",
                    }
                ];

                return events;
            };

            eventFactory.IrishLotteryDefaultEvents = function() {
                var events =
                [
                    {
                        EventNumber: 1,
                        EventTime: 71100000,
                        Status: "I",
                    },
                    {
                        EventNumber: 2,
                        EventTime: 71100000,
                        Status: "I",
                    },
                    {
                        EventNumber: 3,
                        EventTime: 71100000,
                        Status: "I",
                    }
                ];

                return events;
            };

            eventFactory.SaveResult = function(id, resultPlaces) {
                var resultDtoAdd = { EventId: id, ResultPlaces: resultPlaces };
                return $http.post(urlBase + '/' + id + '/addResult', resultDtoAdd);
            };

            eventFactory.SaveEventExtraInfo = function(id, eventExtraInfoDto) {
                return $http.post(urlBase + '/' + id + '/SaveEventExtraInfo', eventExtraInfoDto);
            };

            eventFactory.GetEventExtraInfo = function(id, ballSetId) {
                return $http.get(urlBase + '/' + id + '/GetEventExtraInfo?ballSetId=' + ballSetId);
            };

            eventFactory.SavePreDrawCertificate = function(id, preDrawCertificate) {
                return $http.post(urlBase + '/' + id + '/SavePreDrawCertificate', preDrawCertificate);
            };

            eventFactory.GetPreDrawCertificate = function (id) {
                return $http.get(urlBase + '/' + id + '/GetPreDrawCertificate');
            };

            eventFactory.GetPreDrawValidation = function (id) {
                return $http.get(urlBase + '/' + id + '/GetPreDrawValidation');
            };

            eventFactory.GetDrawApprovalDto = function (id) {
                return $http.get(urlBase + '/' + id + '/GetDrawApprovalDto');
            };

            eventFactory.PublishResultWithRandomResultChallenge = function (id, randomResultChallenge) {
                return $http.post(urlBase + '/' + id + '/PublishResultWithRandomResultChallenge', randomResultChallenge);
            };

            eventFactory.CanAccessTheEvent = function(id) {
                return $http.get(urlBase + '/' + id + '/CanAccessTheEvent');
            };

        return eventFactory;
        }
    ]);